import { render, staticRenderFns } from "./LoginForReviewer.vue?vue&type=template&id=715be049"
import script from "./LoginForReviewer.vue?vue&type=script&lang=js"
export * from "./LoginForReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports